<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :checkbox-config="checkboxConfig"
            :toolbar-config="toolbarConfig"
            :print-config="printConfig"
            :export-config="exportConfig"
            ref="grid"
            :cellClick="chooseRow"
            :cellDbClick="updateRow"
            @toolbar-addData="addRow"
            @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="showLog()">日志列表</vxe-button>
        <vxe-button @click="execute">执行</vxe-button>
        <vxe-button @click="pause">暂停</vxe-button>
        <vxe-button @click="restore">恢复</vxe-button>

      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
        title="定时任务"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="editModalVisible"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>

    <!-- 执行日志列表 -->
    <a-modal
        title="执行日志"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="logModalVisible"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <logList :jobId=jobId
               v-if="logModalVisible"
               ref="logList"
               @cancelled="closeLog"
               @saved="closeLog">
      </logList>
    </a-modal>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter";
import api from '@/services/api';
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

// import {dataApi} from '@/services/comm/userManage';
// console.log(dataApi)

import detailForm from "@/pages/web/client/timedTask/timedTaskDetail";
import logList from "@/pages/web/client/timedTask/logList";

//弹出层组件
import {mapState} from "vuex";

//接口api
import {dataApi} from '@/services/client/timedTask';

const STATUSARR = {
  "0": "正常",
  "1": "暂停",
};

function formatStatus({cellValue}) {
  let s = STATUSARR[String(cellValue).toUpperCase()];
  return s || "-";
}

const fac = XGrid.factory;

//列表接口
const url = api.comm.SCHEDULE;

//主键
const rowId = 'jobId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),

  fac.makeColumn("beanName", "bean名称", 350),
  fac.makeColumn("methodName", "方法名称", 240),
  fac.makeColumn("params", "参数", 320, 'center', true,),
  fac.makeColumn("cronExpression", "cron表达式", 220, 'center'),
  fac.makeColumn("remark", "备注", 260, 'center'),
  fac.makeColumn({
    field: "status",
    title: "状态",
    width: 140,
    align: 'center',
    formatter: formatStatus
  }),
  // fac.makeColumn("status", "状态", 160, 'center',formatter: formatStatus),
]


// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: 'beanName'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: false,
  import: false,
  delData: true,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

const popConfig = fac.makePopConfig(['logList']);

export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm,
    logList,
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      logModalVisible: false,
      jobId: 0
    }
  },
  methods: {
    closeLog() {
      this.logModalVisible = false;
    },
    async showLog() {
      //  查看日志列表
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length != 1) {
        this.$message.error('请选择一条数据');
        return false;
      }
      console.log(rows);
      this.jobId = rows[0].jobId
      this.logModalVisible = true;
    },
    async execute() {
      //  执行
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请至少选择一条数据');
        return false;
      }
      const idList = rows.map((i) => {
        return i.jobId;
      });
      await dataApi.execute(idList).then(() => {
        this.$message.success('操作成功');
        this.refresh();
      }).catch(e => {
        this.$message.error(e.msg)
        console.log(e);
      }).finally(() => {
        this.form.resetFields();//重置表单内容
      });
    },
    async pause() {
      //  暂停
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请至少选择一条数据');
        return false;
      }
      const idList = rows.map((i) => {
        return i.jobId;
      });
      await dataApi.pause(idList).then(() => {
        this.$message.success('操作成功');
        this.refresh();
      }).catch(e => {
        this.$message.error(e.msg)
        console.log(e);
      }).finally(() => {
        this.form.resetFields();//重置表单内容
      });
    },
    async restore() {
      //  恢复
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请至少选择一条数据');
        return false;
      }
      const idList = rows.map((i) => {
        return i.jobId;
      });
      await dataApi.restore(idList).then(() => {
        this.$message.success('操作成功');
        this.refresh();
      }).catch(e => {
        this.$message.error(e.msg)
        console.log(e);
      }).finally(() => {
        this.form.resetFields();//重置表单内容
      });
    },
    async deleteReply() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请至少选择一条数据');
        return false;
      }
      const idList = rows.map((i) => {
        return i.cmtId;
      });
      await dataApi.deleteSkuCmt(idList).then(() => {
        this.$message.success('操作成功');
        this.refresh();
      }).catch(e => {
        this.$message.error(e.msg)
        console.log(e);
      }).finally(() => {
        this.form.resetFields();//重置表单内容
      });
    },
    deleteReady() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length < 1) {
        this.$message.error('请至少选择一条数据');
        return false;
      }
    },
  }
}
</script>

<style scoped>
</style>
